import {forkJoin as observableForkJoin,  of ,  Observable } from 'rxjs';
import {first, mergeMap} from 'rxjs/operators';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { UserService } from '../services/user.service';

@Component({
    template: `
        <div mat-dialog-title>Add User</div>
        <div mat-dialog-content>
            <form #editUserForm="ngForm">
                <mat-form-field>
                    <input name="firstName" #firstName="ngModel" matInput placeholder="First" [(ngModel)]="user.firstName" required>
                    <mat-error *ngIf="firstName.hasError('required')">required</mat-error>
                </mat-form-field>
                <mat-form-field class="right-field">
                    <input name="lastName" #lastName="ngModel" matInput placeholder="Last" [(ngModel)]="user.lastName" required>
                    <mat-error *ngIf="lastName.hasError('required')">required</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <input name="password" 
                           #password="ngModel" 
                           matInput 
                           type="password" 
                           placeholder="Password" 
                           [(ngModel)]="user.passwordHash" 
                           validateEqual="confirmPassword" 
                           reverse="true" 
                           pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$" 
                           required>
                    <mat-error *ngIf="password.hasError('required')">required</mat-error>
                    <mat-error *ngIf="password.hasError('pattern')">must contain at least one upper case letter, one lowercase letter, one number and be at least 8 characters long.</mat-error>
                </mat-form-field>
                <mat-form-field class="right-field">
                    <input name="confirmPassword" 
                           #confirmPassword="ngModel" 
                           matInput type="password" 
                           placeholder="Confirm Password" 
                           [(ngModel)]="user.confirmPassword" 
                           validateEqual="password" 
                           reverse="false" 
                           required>
                    <mat-error *ngIf="confirmPassword.hasError('required')">required</mat-error>
                    <mat-error *ngIf="confirmPassword.hasError('validateEqual')">passwords must match</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <input name="emailAddress" 
                           #adminEmailAddress="ngModel" 
                           matInput 
                           placeholder="Email" 
                           [(ngModel)]="user.emailAddress" 
                           pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$" 
                           required 
                           maxlength="256"
                           validateUniqueEmail
                           [hostname]="hostname">
                    <mat-error *ngIf="adminEmailAddress.hasError('required')">required</mat-error>
                    <mat-error *ngIf="adminEmailAddress.hasError('pattern')">must be a valid email address</mat-error>
                    <mat-error *ngIf="adminEmailAddress.hasError('validateUniqueEmail')">Email address is already used</mat-error>
                </mat-form-field>
                <mat-checkbox name="isAdmin" [(ngModel)]="isAdmin">Admin</mat-checkbox>
                <mat-checkbox name="isTopicCreator" [(ngModel)]="isTopicCreator">Topic Creator</mat-checkbox>
            </form>
        </div>
        <div mat-dialog-actions>
            <button mat-raised-button color="primary" [disabled]="editUserForm.form.invalid || isUnchanged()" (click)="save()">Save</button>
            <button mat-button mat-dialog-close>Cancel</button>
        </div>
    `
})
export class AddUserDialogComponent {
    user: any;
    hostname: string;
    originalUser: any;
    isAdmin: boolean;
    isTopicCreator: boolean;

    constructor(@Inject(MAT_DIALOG_DATA) public data: { hostname, tenantId }, 
                private dialogRef: MatDialogRef<AddUserDialogComponent>, 
                private userService: UserService) {
        this.hostname = data.hostname;
        this.user = { tenantId: data.tenantId, status: 'ACTIVE' };
        this.originalUser = _.cloneDeep(this.user);
    }

    isUnchanged = () => _.isEqual(this.user, this.originalUser);

    save = () => this.userService.addNewUsers([this.user], { params: { childTenancy: true } })
    .pipe(
        mergeMap(users => {
            const user = users[0];
            return observableForkJoin(
                this.isAdmin ? this.userService.addTenantRole(user.id, user.tenantId, 'TENANT_ADMIN') : of(''),
                this.isTopicCreator ? this.userService.addTenantRole(user.id, user.tenantId, 'STREAM_CREATOR'): of(''),
                of(user)
            )
        }),
        first()
    ).subscribe(
        user => this.dialogRef.close(user), 
        err => console.log('Error', err)
    );
};